// extracted by mini-css-extract-plugin
module.exports = {"toggle":"ToggleTheme_toggle__1rZoO"};